export const tableOption = {
    dialogDrag: true,
    border: true,
    indexLabel: '序号',
    stripe: true,
    menuAlign: 'center',
    align: 'center',
    menuType: 'text',
    searchShow: false,
    excelBtn: true,
    printBtn: true,
    viewBtn: true,
    searchMenuSpan: 6,
    column: [
            {
            label: 'null',
            prop: 'id',
            sortable: true,
            rules: [
                                ]
        },
            {
            label: 'null',
            prop: 'regionCode',
            sortable: true,
            rules: [
                                    {
                        max: 300,
                        message: '长度在不能超过300个字符'
                    },
                ]
        },
            {
            label: 'null',
            prop: 'regionName',
            sortable: true,
            rules: [
                                    {
                        max: 300,
                        message: '长度在不能超过300个字符'
                    },
                ]
        },
            {
            label: 'null',
            prop: 'parentId',
            sortable: true,
            rules: [
                                ]
        },
            {
            label: 'null',
            prop: 'regionNameEn',
            sortable: true,
            rules: [
                                    {
                        max: 300,
                        message: '长度在不能超过300个字符'
                    },
                ]
        },
            {
            label: 'null',
            prop: 'regionShortnameEn',
            sortable: true,
            rules: [
                                    {
                        max: 30,
                        message: '长度在不能超过30个字符'
                    },
                ]
        },
            {
            label: 'null',
            prop: 'level',
            sortable: true,
            rules: [
                                ]
        },
            ]
}
